import React from 'react';
import { PRODUCT, SUPPORT_EMAIL } from '../data/constants';
export function Footer() {
  return <footer className="border-t-4 border-gold bg-forest py-4" data-id="element-57" data-mp="3gfsjo3v2keir">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-58" data-mp="3gh3rcermy6f5">
        <p className="text-xs leading-snug text-white/70 sm:text-sm" data-id="element-59" data-mp="32p5nojgp12qd">
          © 2026 {PRODUCT} — All Rights Reserved. {PRODUCT} is an educational and
          professional reference resource. It does not guarantee identification or correction
          of plant nutritional disorders and does not replace laboratory testing,
          crop-specific recommendations, applicable agricultural regulations, product
          instructions, or qualified agronomic judgment.
        </p>
        <p className="mt-1.5 text-xs font-semibold uppercase tracking-wide text-white/70 sm:text-sm" data-id="element-60" data-mp="3qcniknv98gxk">
          Terms &amp; Conditions • Privacy Policy • Contact
        </p>
        <p className="mt-1 text-xs text-white/70 sm:text-sm" data-id="element-61" data-mp="2ey9wnok2abk6">
          Support:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-white underline decoration-gold underline-offset-2 transition-colors duration-150 ease-out hover:text-gold" data-id="element-62" data-mp="2evxb71f3hj2d">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </footer>;
}